export default (redirectUrl) => {
  if (!redirectUrl) return

  if (redirectUrl.indexOf('#') > -1) {
    window.location.hash = redirectUrl.split('#')[1]
    if (window.location.href.indexOf(redirectUrl.split('#')[0]) > -1) {
      return window.location.reload()
    }
  }

  window.location.href = redirectUrl
}
